import { useRouter } from 'next/router'

import { HtmlLocale } from '~/types/locale'

export default function useLocale(): HtmlLocale {
  const { locale: language } = useRouter()

  switch (language) {
    case 'en':
      return HtmlLocale.EN
    case 'no':
      return HtmlLocale.NO
    case 'uk':
      return HtmlLocale.UA
    default:
      return HtmlLocale.EN
  }
}
